import React, {useEffect} from 'react';
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';

import {store, persistor} from './index.jsx';
import {ProviderContext} from './context';
import SubscriptionsHOCComponent from './subscriptions';

export default ({children}) => {
    const {dispatch} = store;

    return (
        <Provider
            context={ProviderContext}
            store={store}
        >
            <PersistGate
                loading={null}
                persistor={persistor}
            >
                <SubscriptionsHOCComponent context={ProviderContext}>
                    {children}
                </SubscriptionsHOCComponent>
            </PersistGate>
        </Provider>
    );
};
